import { useGetChannelOwnerships } from '@/api/channel'
import pagePath from '@/utils/pagePath'
import { useNavigate, useParams } from 'react-router'
import { useEffect, useMemo } from 'react'

export const useManagePageQueryParams = () => {
  const { email } = useParams()
  const { data: channels, isFetched } = useGetChannelOwnerships()
  const navigate = useNavigate()

  const selectedChannel = useMemo(() => {
    if (!isFetched) return null
    if (typeof email !== 'string') return null
    return channels?.find(channel => channel.email === email) ?? null
  }, [email, channels, isFetched])

  useEffect(() => {
    if (!isFetched) return
    if (typeof email !== 'string') return

    if (!channels?.length) {
      navigate(pagePath.verifyChannel, { replace: true })
      return
    }

    const channel = channels?.find(channel => channel.email === email)
    if (!channel) {
      navigate(pagePath.channelVideos(channels[0].email), { replace: true })
      return
    }
  }, [email, channels, isFetched, navigate])

  return { email, selectedChannel, channels }
}
